import React from "react";
import { utaProfileUrl } from "../../../utils/utaProfile";

// Wraps a faculty name in a link to their uta.edu profile, or renders the name unchanged
// when there is no NetID. Names sit inside clickable rows, so the click stays on the link.
const UtaProfileLink = ({ username, children }) => {
  const href = utaProfileUrl(username);
  if (!href) return <>{children}</>;
  return (
    <a
      className="uta-profile-link"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title="Open the UTA faculty profile in a new tab"
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </a>
  );
};

export default UtaProfileLink;
